import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="bg-background-100" aria-labelledby="category-title">
      <div className="mx-auto w-full px-4 py-16 md:px-6 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="内容分区"
            title={<span id="category-title">六个分区，覆盖吃瓜全流程</span>}
            desc="从梗的来源考据到衍生表情包，再到评论区神评，每个分区都有自己的整理方式。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category, index) => (
            <Reveal key={category.key} delay={index * 60}>
              <Link
                to={`/topics?category=${category.key}`}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-600">
                    <i className={category.icon} aria-hidden="true"></i>
                  </span>
                  <span className="font-heading text-2xl text-background-300">{category.count}</span>
                </div>
                <h3 className="mt-5 text-lg font-medium text-foreground-950 group-hover:text-primary-700">
                  {category.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 font-label text-sm text-secondary-700">
                  进入分区
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}